import { render, staticRenderFns } from "./AcessarAtaDocumentosView.vue?vue&type=template&id=5adccf90&scoped=true"
import script from "./AcessarAtaDocumentosView.vue?vue&type=script&lang=js"
export * from "./AcessarAtaDocumentosView.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaDocumentosView.vue?vue&type=style&index=0&id=5adccf90&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adccf90",
  null
  
)

export default component.exports